var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrap_R",
      class: _vm.auto_fixed ? "auto_fixed" : "w750",
      style: { height: _vm.myHeight }
    },
    [
      _c(
        "div",
        [
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "16px",
                "font-family": "PingFang SC",
                "font-weight": "bold",
                color: "#343434"
              }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("i18n_cost_calculation")) + "\n  "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "Item_Right animate__animated animate__fadeInRight"
            },
            [
              _c("p", { staticClass: "tit" }, [
                _vm._v(_vm._s(_vm.$t("i18n_shipping_cost")))
              ]),
              _vm._v(" "),
              _vm._l(_vm.transportFeeForAir.goodsTypeFeeDTOS, function(
                item,
                index
              ) {
                return _c("p", { key: index, staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(item.goodsTypeName))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("(" + _vm._s(item.calDesc) + ")")
                  ])
                ])
              }),
              _vm._v(" "),
              _c("p", { staticClass: "coutText" }, [
                _c("span", { staticClass: "littit" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "fontString" }, [
                  _vm._v(
                    _vm._s(_vm.transportFeeForAir.currency) +
                      _vm._s(_vm.transportFeeForAir.amount || "0.00")
                  )
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: {
                "enter-active-class": "animate__animated animate__fadeInRight",
                "leave-active-class": "animate__animated animate__fadeOutRight"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pickFeeChecked,
                      expression: "pickFeeChecked"
                    }
                  ],
                  staticClass: "Item_Right"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "tit",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.$t("i18n_pickup_fee")))]),
                      _vm._v(" "),
                      _vm.pickFeeForAir.minKilometer != null &&
                      _vm.pickFeeForAir.maxKilometer != null
                        ? _c(
                            "span",
                            {
                              attrs: {
                                s: "",
                                tyle: "font-size:13px;font-weight: 500;"
                              }
                            },
                            [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(
                                    _vm.pickFeeForAir.minKilometer + "KM"
                                  ) +
                                  "\n          --\n          " +
                                  _vm._s(
                                    _vm.pickFeeForAir.maxKilometer + "KM"
                                  ) +
                                  ")\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_pickup_at_original_port")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        " CNY " + _vm._s(_vm.pickFeeForAir.cnyamount || "0.00")
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.allMoreFeeInfo.amount > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "OrderDetails Item_Right animate__animated animate__bounceInRight",
                  staticStyle: { height: "110px", overflow: "auto" },
                  attrs: { id: "moreFee" }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.feeList, function(item, index) {
                    return _c("div", { key: index }, [
                      item.checked
                        ? _c("p", { staticClass: "coutText" }, [
                            _c("span", { staticClass: "littit" }, [
                              _vm._v(_vm._s(item.feeName))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "fontString animate__animated animate__bounceInRight"
                              },
                              [
                                _vm._v(
                                  _vm._s(item.currency) + _vm._s(item.amount)
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.checked && item.amount2
                        ? _c("p", { staticClass: "coutText" }, [
                            _c("span", { staticClass: "littit" }, [
                              _vm._v(_vm._s(item.feeName) + "手续费")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "fontString" }, [
                              _vm._v(
                                _vm._s(item.currency) + _vm._s(item.amount2)
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "fontString",
                        staticStyle: { "text-align": "right" }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.allMoreFeeInfo.totalExpense)
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "Item_Right" }, [
            _c(
              "p",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between"
                }
              },
              [
                _c(
                  "span",
                  { staticClass: "littit", staticStyle: { width: "100px" } },
                  [_vm._v(_vm._s(_vm.$t("i18n_total_cost")))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "fontString",
                    staticStyle: { "text-align": "right" }
                  },
                  [_vm._v(_vm._s(_vm.currencyCollection))]
                )
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "coutText" }, [
              _c("span", { staticClass: "littit" }, [
                _vm._v(_vm._s(_vm.$t("i18n_Covert_to_CNY")))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "fontString" }, [
                _vm._v("CNY " + _vm._s(_vm.calculatePrice))
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "100%", float: "left" } }, [
        _c("div", { staticStyle: { width: "100%" } }),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "100%", "margin-top": "10px" } },
          [
            _c(
              "el-button",
              {
                staticStyle: {
                  width: "100%",
                  background: "#5AB53C",
                  color: "#ffffff"
                },
                on: { click: _vm.submitOrder }
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("i18n_submit_order")) + " ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { display: "flex", "justify-content": "space-between" } },
      [
        _c("span", { staticClass: "tit", staticStyle: { width: "100px" } }, [
          _vm._v("增值服务费用")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "fontString" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b2ef75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b2ef75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/component/fee-detail.vue
// module id = null
// module chunks = 